import { AbstractControl, ValidatorFn, Validators } from "@angular/forms";
import { Subscription } from "rxjs";

/**
 * Sets conditional validators on a control based on the value of another control.
 *
 * @param triggerControl The control whose value determines whether validators are applied
 * @param targetControl The control to apply validators to
 * @param conditionFn A function that returns `true` if validators should be applied
 * @param validators The validators to apply when the condition is true
 * @returns Subscription to the valueChanges observable (unsubscribe if needed)
 */
export function setCustomValidators(
  triggerControl: AbstractControl,
  targetControl: AbstractControl,
  conditionFn: (value: any) => boolean,
  validators: ValidatorFn[]
): Subscription {
  return triggerControl.valueChanges.subscribe((value) => {
    if (conditionFn(value)) {
      targetControl.setValidators(validators);
    } else {
      targetControl.clearValidators();
    }
    targetControl.updateValueAndValidity();
  });
}
